import { EventInterface } from "@shop/frontend/web/js/interfaces/EventInterface";
import { eventHelper } from "../helpers/EventHelper";
import { INITIAL_EVENT_ORDER } from "@shop/frontend/web/js/constants/event";
import { helpers } from "@shop/frontend/web/js/helpers";
import { EventInteractPlan } from "../components/EventInteractPlan";
import { arrayHelper } from "@shop/frontend/web/js/helpers/ArrayHelper";
import api from "@shop/frontend/web/js/api";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { Modal } from "@shop/frontend/web/js/components/Modal";

import { EventOrderBottom } from "../components/EventOrderBottom/EventOrderBottom";
import { EventView } from "../views/EventView";

class EventController extends EventInterface {
	constructor() {
		super();

		/* Объявляем компоненты */
		this.interactPlan = new EventInteractPlan();
		this.eventOrderBottom = new EventOrderBottom();
		this.modal = new Modal();

		/* Создаем представления */
		this.view = new EventView();

		/* Инициализация событии */
		super.initEventEmitter();
	}

	/* Инициализция подписчиков */
	setUpSubscribers() {
		/**
		 * Подписчик который срабатывает после загрузки мероприятия
		 * @event EventController#event:after-load-event
		 */
		this.emitter.subscribe("event:after-load-event", () => {
			/* добавляем в модель информацию об евенте */
			this.model.setEventId(this.view.$placesContainer.data("event"));
			this.model.unitId = $("#js-svg").data("unit");
			this.model.settings.validateAndAddSettings(this.view.getPlacesSettings());

			if (this.model.settings.hasChildTicket) this.view.showChildTicketInfo();
			if (window.location.pathname.includes("event") && !helpers.isDesktop.matches)
				this.view.showEventOnPopup();

			if (INITIAL_EVENT_ORDER)
				this.eventOrderBottom.updateOrder(INITIAL_EVENT_ORDER, this.model.getEventId());

			if (eventHelper.isStadiumPlan()) {
				api.event.getZones({ eventId: this.model.getEventId() }).then(res => {
					if (!res.zones) return this.modal.show(`Не удалось получить ценовые зоны!`);
					this.model.zones = arrayHelper.convertObjectToArray(res.zones);
					this.model.zones = this.model.removeZeroPriceZones(this.model.zones);
					this.interactPlan.renderStadiumPriceLegend(this.model.zones);
				});
				if ($("#js-change-svg svg").find("g[mode=2]").length > 0) {
					this.view.updateTextSize();

					api.event.getPrices({ eventId: this.model.getEventId() }).then(res => {
						if (!res.prices)
							return this.modal.show("Не удалось получить ценовые зоны!");

						eventHelper.setAttributesToPlaces({
							prices: res.prices,
							zones: res.zones,
						});
					});
				}
			} else {
				this.view.updateTextSize();

				api.event.getPrices({ eventId: this.model.getEventId() }).then(res => {
					if (!res.prices) return this.modal.show(`Не удалось получить ценовые зоны!`);
					this.interactPlan.updatePlacesPrices(res);
				});
			}

			/* Инициализируем работу с планом */
			this.interactPlan.init({
				model: {
					eventId: this.model.getEventId(),
					unitId: this.model.unitId,
				},
				settings: this.model.settings.getSettings(),
				onLoadSector: ({ viewId }) => {
					this.model.currentViewId = viewId;
					this.view.updateTextSize();
					this.interactPlan.setActivePlaces(this.eventOrderBottom.getOrderCarts());
				},
				onLoadStadium: () => {
					this.model.currentViewId = null;
				},
				tapOnPlace: place => tapOnPlaceHandler(place),
			});
		});

		/**
		 * При нажатии на активное место добавляет
		 * или удаляет из корзины и возвращает событие
		 * @property {SVGGElement} $activePlace
		 */
		const tapOnPlaceHandler = $activePlace => {
			const sid = $activePlace.attr("id");
			const uid = $activePlace.attr("uid");
			const priceId = $activePlace.attr("price-id");

			/* Если место уже активное то удаляем из корзины */
			if ($activePlace.attr("data-available") === "false")
				return this.emitter.emit("event:remove-from-cart", { sid, uid, priceId });

			return this.emitter.emit("event:add-to-cart", sid);
		};

		/**
		 * Удаляет место из корзины
		 * @event EventController#event:remove-from-cart
		 */
		this.emitter.subscribe("event:remove-from-cart", ({ sid, uid, priceId }) => {
			return api.eventCart
				.removeFromCart({
					eventId: this.model.eventId,
					sid: sid,
					uid: uid,
					viewId: this.model.currentViewId,
				})
				.then(res => {
					if (res.error) throw new Error(res.msg);
					if (res.redraw)
						return this.modal.show("Данное место больше недоступно. Выберите другое.");
					if (!res.carts) return false;

					window.CartService.count = window.CartService.count - 1;
					window.CartService.updateCount();
					if (res.active_carts[this.model.eventId]) {
						this.eventOrderBottom.removeActiveCarts(res.carts, res.active_carts[this.model.eventId].carts);
					} else {
						this.eventOrderBottom.removeActiveCarts(res.carts);
					}
					this.interactPlan.removeActivePlaces(res.carts);
				})
				.catch(err =>
					this.modal.show(
						`
						${translator.t("main", "An error occurred when deleting from the basket!")}
						<p>${err.message}</p>
						`
					)
				);
		});

		/**
		 * Подписчик который добавляет место в корзину
		 * @event EventController#event:add-to-cart
		 */
		this.emitter.subscribe("event:add-to-cart", sid => {
			api.eventCart
				.addToCart({
					eventId: this.model.eventId,
					sid: sid,
					viewId: this.model.currentViewId,
				})
				.then(res => {
					if (res.need_auth) return this.modal.show("Необходима авторизация!");
					if (res.error) return this.modal.show(res.msg);
					if (res.limit)
						return this.modal.show(
							"Вы превысили максимально допустимое количество мест для брони."
						);
					if (res.redraw) {
						this.interactPlan.loadPlacesPrices({
							viewId: this.model.currentViewId,
							clearCache: true,
						});
						return this.modal.show("Данное место больше недоступно. Выберите другое.");
					}

					/* Обновляем счетчик корзины */
					window.CartService.count = window.CartService.count + 1;
					window.CartService.updateCount();

					/* Выводим заказ */
					this.eventOrderBottom.updateOrder(res.order, this.model.getEventId());
					/* Показываем активные места на плане */
					this.interactPlan.setActivePlaces(this.eventOrderBottom.getOrderCarts());
				})
				.catch(err => {
					console.log(err);
					this.modal.show(
						`
						${translator.t("main", "An error occurred when adding to the basket!")}
						<p>${err.message}</p>
						`
					);
				});
		});

		/**
		 * Делает запрос на очистку корзины
		 * @event EventController#event:clear-cart
		 */
		this.emitter.subscribe("event:clear-cart", () => {
			api.eventCart
				.removeEventFromOrder({
					eventId: this.model.eventId,
					orderId: this.eventOrderBottom.getOrderId(),
				})
				.then(res => {
					if (res.error)
						return this.modal.show(res.msg ? res.msg : "Неизвестная ошибка!");

					if (res.refresh) return window.location.reload();

					if (!res.success)
						return this.modal.show(
							`${translator.t(
								"main",
								"An error occurred when deleting from the basket!"
							)}`
						);

					/* Очищаем активные места на плане */
					this.interactPlan.removeActivePlaces(this.eventOrderBottom.getOrderCarts());

					/* Очищаем корзину */
					this.eventOrderBottom.clearOrder();
				})
				.catch(err =>
					this.modal.show(
						`${translator.t(
							"main",
							"An error occurred when deleting from the basket!"
						)}`
					)
				);
		});
	}

	/* Инициализция обработчиков */
	setUpListeners() {
		this.eventOrderBottom.on("clear", () => this.emitter.emit("event:clear-cart"));
		this.eventOrderBottom.on("remove-ticket", ({ sid, uid, priceId }) =>
			this.emitter.emit("event:remove-from-cart", { sid, uid, priceId })
		);

		if (!helpers.isDesktop.matches) {
			this.eventOrderBottom.pane("show", () =>
				$("#js-places-change").css("padding-bottom", "138px")
			);
			this.eventOrderBottom.pane("hide", () =>
				$("#js-places-change").css("padding-bottom", "0")
			);
		}

		$(window).on("resize", () => {
			if (!helpers.isDesktop.matches) {
				if (this.view.$popupModal.hasClass("i-modal_mobile-fixed")) return true;
				return this.view.showEventOnPopup();
			}

			if (this.view.$popupModal && this.view.$popupModal.hasClass("i-modal_mobile-fixed"))
				return this.view.returnEventFromPopup();

			return true;
		});

		/* Инициализация страницы евента */
		this.emitter.emit("event:after-load-event");
	}
}

export const eventController = new EventController();
